import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Global search controller connected!")
  }

  search(event) {
    console.log("Search triggered!", event.target.value)
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, 300)
  }

  performSearch() {
    console.log("Performing search...")
    const form = document.getElementById('global-search-form')
    const input = document.getElementById('global-search-input')
    const resultsDiv = document.getElementById('search-results')
    
    const url = form.action + '?query=' + encodeURIComponent(input.value)
    console.log("Fetching:", url)
    
    fetch(url, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      console.log("Response received:", response)
      return response.text()
    })
    .then(html => {
      console.log("HTML received:", html.substring(0, 100))
      resultsDiv.innerHTML = html
    })
    .catch(error => console.error('Search error:', error))
  }
}